import { render, staticRenderFns } from "./SelectPrizeModal.vue?vue&type=template&id=abbb1f36&scoped=true&"
import script from "./SelectPrizeModal.vue?vue&type=script&lang=js&"
export * from "./SelectPrizeModal.vue?vue&type=script&lang=js&"
import style0 from "./SelectPrizeModal.vue?vue&type=style&index=0&id=abbb1f36&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abbb1f36",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
